import { Button, Chip } from '@material-ui/core'
import { StyledTag } from 'components/Tag/Tag.style'
import styled from 'styled-components'

export const AddressRowContainerStyled = styled.div`
  width: 100%;
  &:hover .from-button-details {
    max-width: 100%;
    width: fit-content;
  }

  &:not(:hover) .from-button-details {
    max-width: 0px;
  }
`

export const StreetContainerStyled = styled.div`
  font-size: 14px;
  line-height: 26px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  gap: 5px;
  color: ${(props) => (props.isHovered ? '#044f98' : '#495057')};
`

export const TownContainerStyled = styled(StyledTag)`
  justify-content: space-between;
`

export const StreetStyled = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ViewDetailsStyled = styled.div`
  font-size: 12px;
  opacity: ${(props) => (props.isHovered ? '1' : '0')};
  transition: opacity 0.5s ease;
`

export const TownStyled = styled.span`
  width: 100%;
`

export const ChipStyled = styled(Chip)`
  width: 100%;
  &:hover {
    cursor: pointer;
  }
`

export const FromContainerStyled = styled.div`
  display: flex;
  line-height: 20px;
  gap: 6px;
  align-items: baseline;
`

export const FromStyled = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #92969a;
`

export const FromButtonStyled = styled(Button)`
  border-radius: ${(props) => (props.isMainHovered ? '2px 0 0 2px' : '2px')};
  background-color: ${(props) => (props.isHovered ? '#c63502 !important' : '#ac2d00 !important')};

  height: 18px !important;
  padding: 0px 4px 0px 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #ffffff;
  text-transform: none;
  min-width: 0px;
  transition: max-width 1s ease;

  .MuiButton-label {
    gap: 4px;
  }

  img {
    height: 16px;
    width: 15px;
    mix-blend-mode: lighten;
  }
`

export const FromButtonDetailsStyled = styled(FromButtonStyled)`
  padding: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  border-radius: 0 2px 2px 0;

  .MuiButton-label {
    padding-left: 4px;
    padding-right: 4px;
    white-space: nowrap;
    display: inline-block;
  }
`
